import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EChartsOption, SeriesOption } from 'echarts';
import { NgxEchartsDirective } from 'ngx-echarts';

type EnergyPeriod = 'week' | 'month';

@Component({
  selector: 'lib-daily-energy-chart',
  standalone: true,
  imports: [MatCardModule, NgxEchartsDirective, TranslateModule],
  templateUrl: './daily-energy-chart.component.html',
  styleUrl: './daily-energy-chart.component.css',
})
export class DailyEnergyChartComponent {
  @Input() categories: string[] = [];
  @Input() series: SeriesOption[] = [];

  @Input() period: EnergyPeriod = 'month';

  @Output() periodChange = new EventEmitter<EnergyPeriod>();

  private translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  chartOption: EChartsOption = {};

  constructor() {
    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.createChartOption();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categories'] || changes['series']) {
      this.createChartOption();
    }
  }

  onPeriodChange(period: EnergyPeriod): void {
    console.log(period)
    if (this.period === period) {
      return;
    }

    this.periodChange.emit(period);
  }

  private createChartOption(): void {
    this.chartOption = {
      tooltip: {
        trigger: 'axis',
      },

      toolbox: {
        right: 10,
        feature: {
          restore: {},
          saveAsImage: {},
        },
      },

      legend: {
        bottom: 0,
        type: 'scroll',
      },

      grid: {
        left: 45,
        right: 20,
        top: 60,
        bottom: 65,
        containLabel: true,
      },

      xAxis: {
        type: 'category',
        data: this.categories,
      },

      yAxis: {
        type: 'value',
        name: this.translate.instant('view_value.energy_kwh'),
      },

      series: this.series,
    };
  }
}